export function loadCartFromStorage(key) {
  const raw = localStorage.getItem(key);
  try {
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveCartToStorage(key, cart) {
  localStorage.setItem(key, JSON.stringify(cart));
}
